import { ArrowRight, Target } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth-context";

const goals = [500, 1000, 2500, 5000];

export function GoalPage() {
  const [selected, setSelected] = useState(500);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const { refresh } = useAuth();
  const navigate = useNavigate();
  const save = async () => {
    setBusy(true);
    setError("");
    try {
      await api.setGoal(selected);
      await refresh();
      navigate("/earn", { replace: true });
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : "Unable to save your goal.");
    } finally {
      setBusy(false);
    }
  };
  return (
    <main className="goal-page">
      <section className="goal-card">
        <span className="goal-icon"><Target /></span>
        <p className="eyebrow">ONE QUICK CHOICE</p>
        <h1>What's your first Bucks goal?</h1>
        <p>Pick a target to make your next earning action feel clear. You can change it later.</p>
        <div className="goal-options" role="radiogroup" aria-label="First Bucks goal">
          {goals.map((goal) => (
            <button className={selected === goal ? "selected" : ""} type="button" role="radio" aria-checked={selected === goal} key={goal} onClick={() => setSelected(goal)}>
              <strong>${goal / 100}</strong>{goal === 500 && <span>RECOMMENDED</span>}
            </button>
          ))}
        </div>
        {error && <div className="form-error" role="alert">{error}</div>}
        <button className="button goal-continue" type="button" onClick={save} disabled={busy}>{busy ? "Saving…" : `Start my $${selected / 100} goal`}<ArrowRight /></button>
        <small>Goals are motivational. Earnings and offer availability aren't guaranteed.</small>
      </section>
    </main>
  );
}
